module.exports = __webpack_public_path__ + "img/生活用纸.c6e494f2.png";